import React from "react";

import { Collapsible } from "../../components";
import { ListingList } from "../../components/listing";
import { Counter, LookbookTopButtons } from "../atoms";
import { ListingsFilters } from "../molecules";
import { LookbookSearchBar } from "../components/lookbook";
import { useListingList } from "../useListingList";
import { useUpsertLookbook } from "../useUpsertLookbook";
import { steps } from "../constants";
import { LookbookListingRow } from "../molecules/LookbookListingRow";

export function SelectListings() {
  const {
    getCollapsibleState,
    toggleCollapsible,
    goToProducts,
  } = useUpsertLookbook();
  const { isOpen, isVisible } = getCollapsibleState(steps.LISTINGS);
  const {
    count,
    listParams,
    onSearchQueryChange,
    sort,
    setSort,
    filter,
    setFilter,
    inStock,
    setInStock,
    isConsignment,
    setConsignment,
  } = useListingList();

  if (!isVisible) {
    return null;
  }

  return (
    <Collapsible
      trigger="Select Listings"
      handleTriggerClick={() => toggleCollapsible(steps.LISTINGS)}
      open={isOpen}
      className="select-listings"
      testId="lookbook-listings"
      noContainer
      overflowWhenOpen="visible"
    >
      <main id="listings-manage" className="lb-select-listings actions-header">
        <div className="lb-select-listings__toolbar">
          <div className="lb-select-listings__search-row">
            <LookbookSearchBar
              placeholder="Quick search for products"
              onUpdate={onSearchQueryChange}
            />

            <LookbookTopButtons
              onNext={goToProducts}
              className="lb-select-listings__next"
            />
          </div>

          <ListingsFilters
            sort={sort}
            setSort={setSort}
            filter={filter}
            setFilter={setFilter}
            inStock={inStock}
            setInStock={setInStock}
            isConsignment={isConsignment}
            setConsignment={setConsignment}
            isYearFilter
            isConditionFilter
            stacked
          />

          <div className="lb-select-listings__header">
            <Counter count={count} variant="lookbook" />
          </div>
        </div>

        <div className="lb-select-listings__list list-container">
          {isOpen && (
            <ListingList
              itemComponent={LookbookListingRow}
              limit={12}
              list="uploaded"
              {...listParams}
            />
          )}
        </div>
      </main>
    </Collapsible>
  );
}
